export default __webpack_public_path__ + "static/aam-logo-c35fa4edc6760f8da36f94c0776452d7.png";